<router-outlet></router-outlet>

<app-cookie-consent></app-cookie-consent>

<!-- WhatsApp Floating Button (Bootstrap) -->
<a
  [href]="whatsappLink"  
  target="_blank"
  rel="noopener"
  aria-label="Chat on WhatsApp"
  title="Chat on WhatsApp"
  class="whatsapp-fab"
>
 <i class="fab fa-whatsapp"  style="color: white;font-size: 2rem;"></i>
</a>

